export function setState(setState) {
    return (changes) => {
        setState((prevState) => (Object.assign(Object.assign({}, prevState), changes)));
    };
}

//# sourceMappingURL=setState.js.map
